export const PricesPageView = 'prices';
